import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import b from 'b_';
import { Tag } from 'client/types/tag';
import { SluggedPage } from 'client/types/common';
import Breadcrumbs from 'client/components/breadcrumbs';
import Button from 'client/components/button';

import TagStub from './tag.stub';

const class_ = b.with('page');

export interface DispatchProps {
    fetchTag(slug: string): any;
}

export interface StateProps {
    data: Tag | null;
    isLoading: boolean;
}

type Props = StateProps & DispatchProps & RouteComponentProps<SluggedPage>;

class TagPage extends Component<Props> {
    componentDidMount() {
        const { fetchTag, data, match } = this.props;
        const { slug } = match.params;

        if (!data || data.slug !== slug) {
            fetchTag(slug);
        }
    }

    render() {
        const { isLoading, data } = this.props;

        if (isLoading) {
            return (<TagStub />);
        }

        if (!data) {
            return null;
        }

        const { name, description } = data;

        return (
            <>
                <Breadcrumbs items={[{ text: name }]} />
                <div className={class_({ type: 'tag' })}>
                    <div className={class_('content')}>
                        <h1>{name}</h1>
                        <h3>{description}</h3>
                        <Button theme="action">
                            Подписаться
                        </Button>
                        <div style={{ fontSize: '14px', marginTop: '5px' }}>
                            Вы получите письмо, когда<br />будет следующее мероприятие.
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(TagPage);
